import { MutationTree } from "vuex";
import { OrderHistoryState } from "./types";

export const mutations: MutationTree<OrderHistoryState> = {};
